import { EcardGuest } from './EcardGuest';
export default EcardGuest;
